import React from "react"
import PropTypes from "prop-types"

//	Components
import MetalSwatches from "components/Stacker/components/MetalSwatches/MetalSwatches"

import "./ProductMetals.scss"
import { useI18nContext } from "i18n/i18n-react"

// this should hold the Product Swatches on PDP page.
function ProductMetals({
  pid,
  productMetals,
  productName = "",
  entryNumber,
  isLink = true,
  isEditCart = false,
  isStackedProduct = false,
  refinerId = null,
  selectedSize,
}) {
  const linkClobber = refinerId ? false : isLink
  const { LL } = useI18nContext()
  return (
    <div className="productMetals d-flex align-items-center">
      <div className="metals-label-text col-3 no-padding">
        <label htmlFor="metal" className="metal-text">
          {LL.productConfig.metalLabel()}
        </label>
      </div>

      <MetalSwatches
        baseProductCode={pid}
        entryNumber={entryNumber}
        isEditCart={isEditCart}
        isLink={linkClobber}
        isStackedProduct={isStackedProduct}
        productMetalVariants={productMetals}
        productName={productName}
        refinerId={refinerId}
        selectedSize={selectedSize}
      />
    </div>
  )
}

ProductMetals.propTypes = {
  entryNumber: PropTypes.string,
  isEditCart: PropTypes.bool,
  isLink: PropTypes.bool,
  isStackedProduct: PropTypes.bool,
  pid: PropTypes.string,
  productMetals: PropTypes.array,
  productName: PropTypes.string,
  refinerId: PropTypes.string,
  selectedSize: PropTypes.object,
}

export default ProductMetals
